export default __webpack_public_path__ + "static/media/close_white_24dp.604f17ae.svg";